import { useState, useEffect } from 'react';

export const useWindowWidth = (size): boolean => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const handleResize = (): void => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setWidth]);

    return width > size;
};
